import React, { useEffect } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  updateModHelperType,
  getModHelperType,
  postModHelperType,
  deleteModHelperType,
} from "../../../_redux/actions/ActionSettings";
import { connect } from "react-redux";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";

const AddHelperType = ({
  updateModHelperType,
  getModHelperType,
  postModHelperType,
  deleteModHelperType,
  helperType,
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    getModHelperType();
  }, [getModHelperType]);

  const { register, handleSubmit, setValue, reset } = useForm({
    mode: "onBlur",
    defaultValues: {},
  });

  const onSubmit = (formData) => {
    if (data) {
      updateModHelperType(formData, data.id);
      setData(null);
      reset();
    } else {
      postModHelperType(formData);
      reset();
    }
  };
  return (
    <Card>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={4}>
              <Form.Group controlId="formGroupName">
                <Form.Label>Helper Type Title</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    {...register("category")}
                    placeholder="eg: Confusion"
                  />
                  {data && (
                    <AiOutlineClose
                      className="position-absolute "
                      size={18}
                      style={{
                        top: "50%",
                        right: "8px",
                        transform: "translate(0,-50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setData(null);
                        setValue("category", "");
                      }}
                    />
                  )}
                </div>
              </Form.Group>
            </Col>

            <Col md={8}>
              <div className="scroll-wrapper">
                <Row>
                  {helperType.length > 0 &&
                    helperType.map((item, index) => (
                      <Col md={6}>
                        <div className="question-type-list d-flex align-items-center justify-content-between">
                          <p>{item.category}</p>
                          <div>
                            <FaEdit
                              className="text-info pointer mr-1"
                              onClick={() => {
                                setValue("category", item.category);
                                setData(item);
                              }}
                            />
                            <FaTrashAlt
                              color="#BC2A20"
                              size={14}
                              className="pointer"
                              onClick={() => deleteModHelperType(item.id)}
                            />
                          </div>
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={2}>
              <Button className="btn-primary btn-round btn-sm" type="submit">
                {data ? "Edit" : "Add"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  helperType: state.moderatorHelper.helperType,
});

const mapDispatchToProps = {
  getModHelperType,
  postModHelperType,
  deleteModHelperType,
  updateModHelperType,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddHelperType);
